import React from "react";
import { Box } from "@mui/material";
import { useResponsiveFontSize } from "../functions";

const Paragraph = ({
  text,
  textAlign = "justify",
  // fontSize = "1rem",
  marginTop = "1rem",
}) => {
  const fontSize = useResponsiveFontSize();
  return (
    <p
      style={{
        fontSize: fontSize,
        marginTop: marginTop,
        fontWeight: "100",
        textAlign: textAlign,
        lineHeight: "1.5rem",
      }}
    >
      {text}
    </p>
  );
};

const Essay = ({ paragraphs, textAlign, fontSize, marginTop }) => {
  return (
    <Box>
      {paragraphs.map((paragraph, index) => (
        <Paragraph
          key={index}
          text={paragraph}
          textAlign={textAlign}
          fontSize={fontSize}
          marginTop={marginTop}
        />
      ))}
    </Box>
  );
};

export default Essay;
